'use strict';

module.exports = function isArrayish(obj) {
	if (!obj) {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && obj.splice instanceof Function);
};



//////////////////
// WEBPACK FOOTER
// ./~/is-arrayish/index.js
// module id = 891
// module chunks = 0